// i18n setup — English, Hindi, Assamese
// Loaded once in App.js. Components use useTranslation() to access strings.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import as from "./locales/as.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
            as: { translation: as },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "hi", "as"],
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "gtw_language",
        },
        interpolation: { escapeValue: false },
    });

export default i18n;

export const LANGUAGES = [
    { code: "en", name: "English", native: "English" },
    { code: "hi", name: "Hindi", native: "हिंदी" },
    { code: "as", name: "Assamese", native: "অসমীয়া" },
];
